import React from 'react';

export default function TextButton({title, onClick}) {
  return (
    <span onClick={onClick} style={{textAlign: 'left', font: 'normal normal medium 15px/19px Montserrat', color: '#FFFFFF', cursor: 'pointer'}}>
      {title}
    </span>
  )
}
